import { render } from "./EventPage.vue?vue&type=template&id=4159d90d"
import script from "./EventPage.vue?vue&type=script&lang=js"
export * from "./EventPage.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./EventPage.vue?vue&type=style&index=0&id=4159d90d&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__